<p>
  For the colors, I used the <a href="https://github.com/c0bra/color-scheme-js">color-scheme.js</a> library by Brian Hann.
</p>
